// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__98GRb","label":"styles_label__XZHj8","caption":"styles_caption__jkhcy","description":"styles_description__8WH2J","content":"styles_content__G0MoB"};